import React from 'react'
import { cn } from './cn'

export function EmptyState({ title, description, action, className, icon }) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      {icon && <div className="mb-4 text-4xl text-secondary-400 dark:text-secondary-500">{icon}</div>}
      <h3 className="text-base font-semibold text-secondary-900 dark:text-secondary-100">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-text-muted dark:text-text-muted-dark">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
